/**
 * Metron + Wellspring brand block.
 *
 * Pairs the Marque with the "METRON" eyebrow (Audiowide, the only place we
 * use it in-app) and the "Wellspring" product wordmark (Titillium Web). Used
 * in the sidebar header and any place that needs to anchor the surface to
 * Metron + Wellspring identity.
 */
import { Marque } from './Marque';

interface BrandBlockProps {
  /** When true, only the marque renders (sidebar collapsed state). */
  compact?: boolean;
  /** Override the product wordmark; defaults to "Wellspring". */
  product?: string;
  className?: string;
}

export function BrandBlock(
  { compact = false, product = 'Wellspring', className }: BrandBlockProps,
) {
  if (compact) {
    return (
      <div className={`flex items-center justify-center text-primary ${className ?? ''}`}>
        <Marque size={28} />
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2.5 ${className ?? ''}`}>
      <span className='text-primary'>
        <Marque size={32} />
      </span>
      <div className='flex flex-col leading-none'>
        <span className='metron-display-eyebrow'>METRON</span>
        <span className='metron-wordmark text-foreground text-lg mt-1'>{product}</span>
      </div>
    </div>
  );
}
